/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:flex;justify-content:center;align-items:center;flex-direction:column}.apply__checkmark[_ngcontent-%COMP%]{margin-top:2.375rem}.apply__send[_ngcontent-%COMP%]{margin:1.5rem auto 3.125rem;font-size:1.5625rem;text-align:center;font-weight:500;max-width:15.875rem}.apply__back[_ngcontent-%COMP%]{margin-bottom:3.125rem}"];
export { styles as styles };
